import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MenuController } from '@ionic/angular';

import { GlobalConstants, WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';
import { PromocionService } from 'src/app/services/promocion/promocion.service';

import { IPromocion } from 'src/app/interfaces/IPromocion';

@Component({
  selector: 'app-promocion',
  templateUrl: './promocion.page.html',
  styleUrls: ['./promocion.page.scss'],
})
export class PromocionPage implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _allPromociones: Array<IPromocion> = [];

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _menuCtrl: MenuController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _promocionSrv: PromocionService) {

    console.log('PromocionPage >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('PromocionPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {
    console.log('PromocionPage >> ionViewDidEnter');

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Promociones', null, null,
      null, null, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });

    this.getAllPromocionesWeb();
  }

  //#endregion Eventos NG

  //#region Eventos Botones

  //#endregion

  //#region Otros Metodos

  public getAllPromocionesWeb() {

    this._promocionSrv.getAllPromocionesWeb().subscribe(() => {
      this._allPromociones = this._promocionSrv.AllPromociones;

      // construye url de las imagenes
      this._allPromociones.forEach(item => {
        item.UrlImagenWeb = WebAPIConstants.URLPromocionImagenes + item.UrlImagenPoS;
      });
    });

  }

  ////#endregion
}
